export const ROOT_PATH="/Nomifasf";
//export const BASE_URL = 'https://quadrumdesarrollo.com.mx/facturacion-nomifast-backend/';
export const BASE_URL = 'https://facturacionquadrum.com.mx/facturacion-nomifast-backend/';

//export const BASE_URL = 'http://localhost:8080/facturacion-nomifast-backend/';
export const TOKEN_QUADRUM_VALIDADOR="TokenQInea";
export const USUARIO_KEY="UserQInea"
export const BEARER="Bearer ";

export const CALENDARIO_ES_MX = {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
    monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    today: "Hoy",
    clear: "Claro"
};

export const FORMATO_FECHA_CALENDAR="dd/MM/yy";

export const DEFAULT_MASKS = {
    pint: /[\d]/,
    int: /[\d]/,
    pnum: /[\d]/,
    money: /[\d\s.]/,
    num: /[\d]/,
    hex: /[0-9a-f]/i,
    email: /[a-z0-9_\-@]/i,
    alpha: /[a-z]/i,
    alphanum: /[a-z0-9]/i,
    alphaspace:/[a-z ]/i,   
    nombre:/[a-z ]/i
};

export const EXPRESION_RFC = /^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$/;
